import React, { useState, useEffect } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { base_url } from "./AdminUsers";


const Settlement = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [settlements, setSettlements] = useState([]);
  const [filteredSettlements, setFilteredSettlements] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchPhone, setSearchPhone] = useState("");

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const FetchUserData = async (specificCode = null) => {
    try {
      const auth = localStorage.getItem("admin");

      const response = await axios.get(`${base_url}/admin/getMySettleHistory`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${auth}`
        },
      });

      const data = response.data.setle || [];

      setSettlements(data);
      setFilteredSettlements(data);
    } catch (error) {
      console.error("Error fetching settlements:", error);
    }
  };

  const handleFilter = (e) => {
    e.preventDefault();

    let filtered = [...settlements];

    if (fromDate) {
      filtered = filtered.filter(item => new Date(item.today) >= new Date(fromDate));
    }

    if (toDate) {
      filtered = filtered.filter(item => new Date(item.today) <= new Date(toDate));
    }

    if (searchPhone.trim() !== "") {
      filtered = filtered.filter(item => item.phone.includes(searchPhone.trim()));
    }

    setFilteredSettlements(filtered);
  };


  useEffect(()=>{
    FetchUserData();
  },[]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);



  return (
    <div className="wrapper">
      <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >

<div className="container-fluid">
  <div className="row">
    <div className="col-12">
      {/* Header Card */}
      <div className="bg-gradient p-3 rounded shadow mb-4" style={{ background: 'linear-gradient(to right, #00c6ff, #0072ff)', color: 'black' }}>
        <h4 className="mb-0"><i className="fas fa-coins me-2"></i>Settlement History</h4>
      </div>

      {/* Filter Card */}
      <div className="bg-white p-4 rounded shadow-sm mb-4 border border-light-subtle">
        <div className="row gy-3 gx-4 align-items-end">
          <div className="col-sm-6 col-md-3">
            <label htmlFor="fromDate" className="form-label"><i className="fas fa-calendar-alt me-2 text-primary"></i>From Date</label>
            <input
              type="date"
              id="fromDate"
              className="form-control shadow-sm"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div className="col-sm-6 col-md-3">
            <label htmlFor="toDate" className="form-label"><i className="fas fa-calendar-alt me-2 text-danger"></i>To Date</label>
            <input
              type="date"
              id="toDate"
              className="form-control shadow-sm"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

          <div className="col-sm-6 col-md-3">
            <label htmlFor="searchPhone" className="form-label">
              <i className="fas fa-user me-2 text-secondary"></i>UserName
            </label>
            <input
              type="text"
              id="searchPhone"
              className="form-control shadow-sm"
              value={searchPhone}
              onChange={(e) => setSearchPhone(e.target.value)}
              placeholder="Search by username"
            />
          </div>


          <div className="col-sm-6 col-md-2">
            <button className="btn btn-success w-100 shadow-sm" onClick={handleFilter}>
              <i className="fas fa-filter me-2"></i>Filter
            </button>
          </div>
        </div>
      </div>

      {/* Settlement Table */}
      <div className="table-responsive shadow rounded">
        <table className="table table-bordered table-hover align-middle text-center">
          <thead className="table-dark">
            <tr>
              <th className="text-center">S No.</th>
              <th className="text-center">User Name</th>
              <th className="text-center">Role</th>
              <th className="text-center">Provider Phone</th>
              <th className="text-center">Provider Role</th>
              <th className="text-center">Amount</th>
              <th className="text-center">Date</th>
            </tr>
          </thead>
          <tbody>
            {filteredSettlements.length > 0 ? (
              filteredSettlements.map((item, index) => (
                <tr key={index}>
                  <td className="text-center">{index + 1}</td>
                  <td className="text-center">{item.phone}</td>
                  <td className="text-center">{item.role}</td>
                  <td className="text-center">{item.providerPhone}</td>
                  <td className="text-center">{item.providerRole}</td>
                  <td className="text-center">{item.amount}</td>
                  <td className="text-center">{item.today}</td>
                </tr>
              ))
            ) : (
              <tr><td colSpan="7">No settlements found</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>



      </div>
    </div>
  );
};

export default Settlement;